import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import PlatformIcon from '@/components/PlatformIcon'

interface CollaborationHeaderProps {
  campaign: any // Using 'any' for now to match original file, should be typed properly if possible but avoiding deep refactor of types
}

const StatusBadge = ({ status }: { status: string }) => {
  const statusStyles: Record<string, string> = {
    bid: 'bg-blue-100 text-blue-800',
    pending: 'bg-orange-100 text-orange-800',
    live: 'bg-green-100 text-green-800',
    completed: 'bg-blue-100 text-blue-800',
    rejected: 'bg-gray-100 text-gray-800',
    pending_brand: 'bg-orange-100 text-orange-800',
  }
  const statusLabels: Record<string, string> = {
    bid: 'New Bid',
    pending: 'Pending',
    live: 'Live',
    completed: 'Completed',
    rejected: 'Rejected',
    pending_brand: 'Waiting for Brand',
  }
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusStyles[status] || 'bg-gray-100 text-gray-800'}`}
    >
      {statusLabels[status] || status}
    </span>
  )
}

const CollaborationHeader = ({ campaign }: CollaborationHeaderProps) => {
  const [imgError, setImgError] = useState(false)
  const hasValidLogo =
    campaign?.brand?.logo &&
    typeof campaign.brand.logo === 'string' &&
    campaign.brand.logo.trim().length > 0

  if (!campaign) return null

  return (
    <Card variant="dark" className="mb-6 p-6">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 rounded-full overflow-hidden bg-white/10 border border-white/20 shrink-0 flex items-center justify-center">
            {hasValidLogo && !imgError ? (
              <img
                src={campaign.brand.logo}
                alt={campaign.brand.name}
                className="h-full w-full object-cover"
                onError={() => setImgError(true)}
              />
            ) : (
              <span className="text-2xl font-bold text-white/50">
                {campaign.brand?.name ? campaign.brand.name.charAt(0).toUpperCase() : 'C'}
              </span>
            )}
          </div>
          <div className="flex flex-col">
            <h1 className="text-2xl font-bold text-white">{campaign.brand.name}</h1>
            <div className="flex items-center gap-2 text-gray-300">
              <PlatformIcon platform={campaign.platform} className="h-5 w-5" />
              <StatusBadge status={campaign.status} />
            </div>
          </div>
        </div>

        <div className="grow"></div>

        {campaign.status === 'pending' && !campaign.postLink && (
          <>
            {!campaign.conceptStatus || campaign.conceptStatus === 'changes_requested' ? (
              <Link to={`/collaborations/${campaign.id}/concept`} className="flex items-center">
                <Button variant="lime">Start Creative Concept</Button>
              </Link>
            ) : campaign.conceptStatus === 'approved' && !campaign.videoReviewStatus ? (
              <Link
                to={`/collaborations/${campaign.id}/upload-review`}
                className="flex items-center"
              >
                <Button variant="lime">Upload Video for Review</Button>
              </Link>
            ) : campaign.videoReviewStatus === 'approved' &&
              campaign.finalVideoStatus !== 'posted' ? (
              <Link
                to={`/collaborations/${campaign.id}/upload-final`}
                className="flex items-center"
              >
                <Button variant="lime">Upload Final Video</Button>
              </Link>
            ) : null}
          </>
        )}
      </div>
    </Card>
  )
}

export default CollaborationHeader
